module.exports = __webpack_public_path__ + "img/a4.7bf69d86.jpg";